import React, { FC } from 'react';
import { observer } from 'mobx-react';
import PollVotesList from '../shared/poll-votes-list';
import PollEntity from '../../../store/polls-store/poll-entity';
import ResponseEntity from '../../../store/polls-store/response-entity';
import FullScreenButton from '../shared/full-screen-button';
import { DEFAULT_STREAM_ADJUSTMENT, FullScreenButtonContent } from '../../../constans/polls-constants';
import PollStatus from '../shared/poll-status/poll-status';
import ClosingProgress from '../shared/closing-progress';

interface IProps {
  poll: PollEntity;
  getPollChoisesList: (pollId: string) => Promise<ResponseEntity[] | void>;
  closeFullScreenMode: () => void;
}

const PollFullScreenContainer: FC<IProps> = ({ poll, getPollChoisesList, closeFullScreenMode }) => {
  return (
    <div className='poll-full-screen-container'>
      <div className='poll-full-screen-header'>
        <FullScreenButton buttonStateContent={FullScreenButtonContent.EXIT} actionHandler={closeFullScreenMode}/>
      </div>
      <div className='poll-full-screen-content-container'>
        <div className='poll-full-screen-content-container-header'>
          {poll.shouldShowClosingProgress
            ? <ClosingProgress delay={DEFAULT_STREAM_ADJUSTMENT} timestamp={poll.pollStatusTimestamp} handleFinishClosing={poll.hideClosingProgress}/>
            : <PollStatus status={poll.status}/>
          }
          <div className='poll-full-screen-content-value'>{poll.value}</div>
        </div>
        <PollVotesList
          responses={poll.getFilteredResponses()}
          countVotes={poll.countVotes}
          getPollChoisesList={getPollChoisesList}
          selectedPollId={poll.getId()}
          shouldHideVotesCount
        />
      </div>
    </div>
  );
};

export default observer(PollFullScreenContainer);
